import { render, staticRenderFns } from "./TackManageList.vue?vue&type=template&id=ef056456&scoped=true&"
import script from "./TackManageList.vue?vue&type=script&lang=js&"
export * from "./TackManageList.vue?vue&type=script&lang=js&"
import style0 from "./TackManageList.vue?vue&type=style&index=0&id=ef056456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef056456",
  null
  
)

export default component.exports